export default __webpack_public_path__ + "static/media/Lucia_Guide.5de32861.pdf";